// Breadcrumb.tsx
import React from 'react';

interface BreadcrumbProps {
  title: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ title }) => {
  return (
    <div data-testid="breadcrumb-container">
      <h1 data-testid="breadcrumb-title" className="text-[24px] font-[700] text-[#000000s]">{title}</h1>
    </div>
  );
};

export default Breadcrumb;